export class ExpressionsErrorListener {
    syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e) {
    }
}
//# sourceMappingURL=ErrorsListener.js.map